// import { Component, OnInit } from "@angular/core";
// import { BidsService } from "./bids.services";
// import { NgxSpinnerService } from "ngx-spinner";
// import { ToastrService } from "ngx-toastr";
// @Component({
//   selector: "app-bids",
//   templateUrl: "./bids.component.html",
//   styleUrls: ["./bids.component.sass"],
// })
// export class BidsComponent implements OnInit {
//   constructor(
//     private bidsService: BidsService,
//     private toastr: ToastrService,
//     private spinner: NgxSpinnerService
//   ) {}

//   ngOnInit(): void {
//     this.getBids("load", 1);
//   }
//   allBids: any[] = [];
//   itemsPerPage: number = 6;
//   totalItems: number = 0;
//   page: number = 1;
//   activePlanType: number = 1;
//   activeTab: "load" | "vacantVehicle" = "load";

//   getBids(type: "load" | "vacantVehicle", page: number) {
//     this.page = page;
//     let data = {
//       limit: this.itemsPerPage,
//       page: page,
//     };

//     let request$ =
//       type === "load"
//         ? this.bidsService.getLoadBids(data)
//         : this.bidsService.getVacantVehicleBids(data);

//     request$.subscribe(
//       (result: any) => {
//         if (result.statusCode === 200) {
//           this.allBids = result.data;
//           this.totalItems = result.pagination?.total || 0;
//         } else {
//           this.toastr.error(result.message);
//         }
//         this.spinner.hide();
//       },
//       (error) => {
//         this.spinner.hide();
//         this.toastr.error("Something went wrong");
//       }
//     );
//   }
// }

import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { BidsService } from "./bids.services";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-bids",
  templateUrl: "./bids.component.html",
  styleUrls: ["./bids.component.sass"],
})
export class BidsComponent implements OnInit {
  allBids: any[] = [];
  itemsPerPage: number = 6;
  totalItems: number = 0;
  page: number = 1;
  activePlanType: number = 1;
  activeTab: "load" | "vacantVehicle" = "load";

  constructor(
    private route: ActivatedRoute,
    private bidsService: BidsService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const type = params["type"] as "load" | "vacantVehicle";
      const id = params["id"];

      this.getBids(type,id);
    });
  }

  getBids(type: "load" | "vacantVehicle", id?: string) {
    let request$ =
      type === "load"
        ? this.bidsService.getLoadBids(id)
        : this.bidsService.getVacantVehicleBids(id);

    this.spinner.show();

    request$.subscribe(
      (result: any) => {
        if (result.statusCode === 200) {
          this.allBids = result.data;
        } else {
          this.toastr.error(result.message);
        }
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
        this.toastr.error("Something went wrong");
      }
    );
  }
}
